module.exports = __webpack_public_path__ + "static/media/prostateguard1.7a007d5b.pdf";